import {BlockModel} from '../../model/block/block.model';

export const isBlockInContainer = (container: {blocks: BlockModel[]}, blockChild: BlockModel) => {
  for (const block of container.blocks) {
    if (block.id === blockChild.id) {
      return true;
    }
  }
  return false;
};